import api from './api';

/**
 * ============
 * 🔐 users USERS
 * ============
 */

// --- Enregistrement d’un nouvel utilisateur ---
/*
export async function registerUser({ email, password, nom, phone  }) {
  const res = await fetch(`${API_BASE}/api/users/add`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(TOKEN ? { usersorization: `Bearer ${TOKEN}` } : {}),
    },
    body: JSON.stringify({ nom, phone, email, password }),
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Erreur lors de la création de compte');
  return data;
}
*/
export const registerUser = async (serviceData) => {
  try {
    const response = await api.post('/api/users/add/web', serviceData);
    if (response.status !== 201) {
        throw new Error("Échec de la création");
      }
      return response.data;
  } catch (error) {
    console.error('Error creating service:', error);
    throw error;
  }
};

export const loginUser = async (credentials) => {
  try {
    const response = await api.post("/api/users/login/web", credentials);
    //console.log(response);
    return response.data; // le backend doit renvoyer le token
  } catch (error) {
    console.error("Erreur lors du login:", error);
    throw error;
  }
};

export const fetchUsers= async () =>  {
  try{
    const response = await api.get("/api/users");
      //console.log(response);
      return response.data.data;
  } catch (error) {
    console.error("Erreur lors du login:", error);
    throw error;
  }
};

export const fetchUsersByCategorie = async (categorieId) => {
  try {
    const response = await api.get(`/api/users/categorie/${categorieId}`);
    return response.data.data; // tableau users
  } catch (error) {
    console.error("Erreur fetchUsersByCategorie:", error);
    return [];
  }
};



/*
// --- Connexion ---
export async function loginUser({ email, password }) {
  const res = await fetch(`${API_BASE}/api/users/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(TOKEN ? { usersorization: `Bearer ${TOKEN}` } : {}),
    },
    body: JSON.stringify({ email, password }),
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Identifiants invalides');
  return data; // contient le token JWT
}

// --- Récupérer tous les utilisateurs (protégé) ---
export async function fetchUsers() {
  const res = await fetch(`${API_BASE}/api/users`, {
    headers: { usersorization: `Bearer ${TOKEN}` },
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Erreur de récupération des utilisateurs');
  return data.data || [];
}

// --- Récupérer un utilisateur par ID ---
export async function fetchUserById(id) {
  const res = await fetch(`${API_BASE}/api/users/${id}`, {
    headers: { usersorization: `Bearer ${TOKEN}` },
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Utilisateur non trouvé');
  return data.data;
}

// --- Mettre à jour un utilisateur ---
export async function updateUser(id, updates) {
  const res = await fetch(`${API_BASE}/api/users/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      usersorization: `Bearer ${TOKEN}`,
    },
    body: JSON.stringify(updates),
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Erreur de mise à jour');
  return data;
}

// --- Supprimer un utilisateur ---
export async function deleteUser(id) {
  const res = await fetch(`${API_BASE}/api/users/${id}`, {
    method: 'DELETE',
    headers: { usersorization: `Bearer ${TOKEN}` },
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Erreur de suppression');
  return data;
}
*/
